// @ts-nocheck
import React, { useCallback, useMemo } from 'react';
import {
  Box,
  IconButton,
  DialogContent,
  Dialog,
  DialogTitle,
  Typography,
  Grid,
  TextField,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';

import useModalDisclosure from '../../../../hooks/useModalDisclosure';
import { checkAttributeIsRequired } from '../../../../utils/Utils';

const ViewParagraph = ({ value, attribute }) => {
  const {
    open: openPreview,
    handleOpen: openModal,
    handleClose: closeModal,
  } = useModalDisclosure();

  const handleClosePreview = useCallback(() => {
    closeModal();
  }, [closeModal]);

  const handleOpenPreview = useCallback(() => {
    openModal();
  }, [openModal]);

  const isAttributeMandatory = useMemo(() => {
    return checkAttributeIsRequired(attribute);
  }, [attribute]);

  return (
    <Grid container xs={12}>
      <Grid item xs={12}>
        <Typography
          variant="body2"
          component="span"
          onClick={handleOpenPreview}
          sx={{
            color: 'primary.main',
            cursor: 'pointer',
            textDecoration: 'underline',
          }}
        >
          View {attribute?.label || 'Paragraph'}
        </Typography>
      </Grid>

      <Dialog
        open={openPreview}
        onClose={handleClosePreview}
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle>
          <Box component="span" aria-live="polite" aria-atomic="true">
            View {attribute?.label}
          </Box>
        </DialogTitle>

        <IconButton
          color="primary"
          aria-label="Close dialog"
          onClick={handleClosePreview}
          sx={{
            position: 'absolute',
            right: 16,
            top: 8,
          }}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent dividers>
          <Grid gap={2} container xs={12}>
            <Grid item xs={12}>
              <TextField
                label={attribute?.label}
                fullWidth
                required={isAttributeMandatory}
                value={value?.title}
                placeholder="Enter a title"
                spellCheck
                type="text"
                disabled={true}
                inputProps={{
                  title: value?.title || '',
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                label={attribute?.justification_label}
                required={isAttributeMandatory}
                value={value?.description}
                placeholder="Enter a description"
                inputProps={{
                  title: value?.description || '',
                }}
                multiline
                minRows={4}
                spellCheck
                disabled={true}
              />
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </Grid>
  );
};

ViewParagraph.propTypes = {
  value: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
  }).isRequired,
  attribute: PropTypes.shape({
    label: PropTypes.string,
    justification_label: PropTypes.string,
  }).isRequired,
};

export default ViewParagraph;
